module.exports = {"id":"dp1_3l3q4","text":"Managing Information","instructions":"Which location allows files to be accessed across multiple devices?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"1.3","questionType":"PickOne","random":true,"options":[{"id":"dp1_3l3q4-a1","text":"Cloud storage service","score":3.7},{"id":"dp1_3l3q4-a2","text":"Local temporary folder","score":1.3},{"id":"dp1_3l3q4-a3","text":"Application cache memory","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.3/l3q4.json
// module id = 974
// module chunks = 41